// extracted by mini-css-extract-plugin
export default {"SectionCallback":"SectionCallback_SectionCallback__nhdAu","inner":"SectionCallback_inner__61AIH","title":"SectionCallback_title__SX935","buttons":"SectionCallback_buttons__IinJC"};